import React, { Suspense } from "react";
import Spinner from "./components/Spinner";
import { NotFound, Redirect, Route, Router, useRouter } from "rhoto-router";
import "./App.scss";
import Analysis from "./components/Analysis";
import StravaLoader from "./components/StravaLoader";
import UserLoader from "./components/UserLoader";
import UserList from "./components/UserList";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

const ActivityList = React.lazy(() => import("./components/ActivityList"));
const EffortModel = React.lazy(() => import("./components/EffortModel"));

// Create a QueryClient instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const RedirectFromSessionStorage = () => {
  const { navigate } = useRouter();
  const redirectBack = window.sessionStorage.getItem("redirect-back");
  if (redirectBack) {
    window.sessionStorage.removeItem("redirect-back");
    navigate(redirectBack);
  }
  return null;
};

const App = () => (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<Spinner />}>
        <UserLoader>
          <Router>
            <RedirectFromSessionStorage />

            <NotFound>
              <Redirect to="/" />
            </NotFound>

            <Route path="/effort/{:userId}">
              <EffortModel />
            </Route>

            <Route exact path="/">
              <ActivityList />
            </Route>

            <Route path="/users">
              <UserList />
            </Route>

            <Route path="/user/:userId">
              <ActivityList />
            </Route>

            <Route path="/activity/:userId/:activityId">
              <StravaLoader>
                <Analysis />
              </StravaLoader>
            </Route>
          </Router>
        </UserLoader>
      </Suspense>
      {process.env.NODE_ENV === "development" && (
        <ReactQueryDevtools initialIsOpen={false} />
      )}
    </QueryClientProvider>
  </React.StrictMode>
);

export default App;
